// extracted by mini-css-extract-plugin
export default {"snowman":"snowMan_snowman__UCu3j","isPlaying":"snowMan_isPlaying__+DrNX","shake":"snowMan_shake__iq3Iq"};